import React from 'react';
import MIcon from '../svgs/mi-icon';
import '../styles/components/scroll-progress.scss';

const ScrollProgress = () =>{
    return (
        <div className="scrollProgress">
            <span className="sideFloatingHeading">WE CREATE CURIOSITY</span>
            <div>
                <span className="dynamic"></span>
            </div>
            <MIcon />
        </div>
    )
}

export default ScrollProgress;